// @flow

import { orderBy } from 'lodash';
import { get, isNil, omitBy } from 'lodash/fp';

const omitNil = omitBy(isNil);

export type OriginalEntry = {
  challengeId: string,
  challengeName: string,
  challengeStartTime: string,
  globalScore: number,
  id: string,
  position: number,
  score: number
};

function normalizeOriginalEntry(entry: Object) {
  return {
    id: entry.id,
    position: entry.position,
    score: entry.fantasy_score,
    globalScore: entry.global_score,
    challengeId: entry.challenge.id,
    challengeName: entry.challenge.name,
    challengeStartTime: entry.challenge.start_time
  };
}

export function normalizeEntry(entry: Object) {
  return {
    countryFlag: get('country.flag', entry.user),
    countryName: get('country.name', entry.user),
    isVIP: !!entry.user.is_vip,
    position: entry.position,
    globalScore: entry.global_score,
    originalEntries: orderBy(
      entry.original_entries.map(normalizeOriginalEntry),
      'globalScore',
      'desc'
    ),
    userAvatar: entry.user.avatar,
    userId: entry.user.id,
    userName: entry.user.name,
    prize: get('label', entry.prize)
  };
}

function decodeUltimateChallenge(data: Object = {}) {
  return omitNil({
    currentUserEntry: data.current_user_entry ? normalizeEntry(data.current_user_entry) : null,
    entered: data.entered,
    entries: data.entries.map(normalizeEntry),
    id: data.id,
    name: data.name,
    startTime: data.start_time,
    updatedTime: data.updated_time
  });
}

export default decodeUltimateChallenge;
